export default __webpack_public_path__ + "images/f7af7a221c46f8e2eb2106f9185655a1-eventbritecircle_logo.svg";